import { FILTER_PAGE_PATH } from '@/config/constants'

export function redirectToFilterPage(hostname, locale) {
  window.location.href = `${hostname}/${locale}${FILTER_PAGE_PATH}`
}

export function findVariantById(variants, id) {
  return variants.find(variant => variant.id === id)
}

export function findVariantIdByRouteColors(variants, routeColors) {
  const matchingVariant = variants.find(variant => {
    return routeColors.every(routeColor => {
      return variant.color.toLowerCase().indexOf(routeColor) > -1
    })
  })
  return matchingVariant?.id
}

export function findVariantIdByGender(variants, gender) {
  return variants.find(variant => variant.gender === gender)?.id
}

export function createRouteColors(colorString) {
  return colorString.toLowerCase().replace(/-?[^0-9a-zA-Z-]+-?/g, '-')
}

export function orderVariantsByNewColors(productGroup) {
  let counter = 0
  const orderedVariants = productGroup.productData.variants.reduce((orderedVariants, variant) => {
    if (variant.labels.includes('new-color')) {
      orderedVariants.splice(counter, 0, variant)
      counter++
    } else orderedVariants.push(variant)
    return orderedVariants
  }, [])
  productGroup.productData.variants = orderedVariants
  return productGroup
}
